import {
  trackingAllowed,
  analyticsAvailable,
  PAGE_TRACKING_STORAGE_KEY as PAGE_KEY,
  EVENT_TRACKING_STORAGE_KEY as EVENT_KEY,
} from '../'
import getConfig from 'next/config'

const { publicRuntimeConfig } = getConfig()

export function setItem(storageKey, newData) {
  try {
    if (typeof localStorage === 'undefined' || !localStorage) return false
    const previousData = JSON.parse(localStorage.getItem(storageKey)) || []
    localStorage.setItem(storageKey, JSON.stringify([...previousData, newData]))
  } catch (error) {}
}

export function passItemsFromStorageToSegment(storageKey, handler) {
  try {
    if (typeof localStorage === 'undefined' || !localStorage) return false
    const items = JSON.parse(localStorage.getItem(storageKey)) || []
    if (items.length === 0) return false
    for (let i = 0; i < items.length; i++) {
      const item = items[i]
      handler(item.handle, item.payload)
    }
    localStorage.removeItem(storageKey)
  } catch (error) {}
}

export function processTrackingStorage() {
  if (!trackingAllowed() || !analyticsAvailable()) return false
  global.analytics.load(publicRuntimeConfig.NEXT_PUBLIC_SEGMENT_WRITEKEY)
  passItemsFromStorageToSegment(PAGE_KEY, global.analytics.page)
  passItemsFromStorageToSegment(EVENT_KEY, global.analytics.track)
}
